import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Self,
  ChangeDetectionStrategy
} from '@angular/core';
import { UntypedFormControl, NgControl } from '@angular/forms';
import { AbstractValueAccessor } from 'ZalamoLibrary/src/lib/core/form/FormControl';
import { CustomConfigOption } from 'ZalamoLibrary/src/lib/ui/products/types';
import { tap } from 'rxjs/operators';

interface SingleOption {
  label: Array<{ language: string; text: string }>;
  description: Array<{ language: string; text: string }>;
  picked: boolean;
  paramId: string;
  icon: string;
}

@Component({
    selector: 'lib-album-size',
    templateUrl: './album-size.component.html',
    styleUrls: ['./album-size.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlbumSizeComponent
  extends AbstractValueAccessor
  implements OnInit
{
  visibleOptions: Array<SingleOption> = [];
  mode: 'select' | 'buttons' = 'select';
  control = new UntypedFormControl();
  @HostBinding('class.iconMode') iconMode = false;
  @Input() type;
  @Input() set options(options: Array<CustomConfigOption>) {
    options = options.filter(({ active }) => active);
    this.mode = 'buttons';
    this.visibleOptions = options.map((options) => ({
      label: options.label,
      description: options.description,
      icon: options.icon,
      width: options.width,
      height: options.height,
      picked:
        this.visibleOptions.find(({ picked }) => picked)?.paramId ===
        options.configId,
      paramId: options.configId,
    }));
    this.iconMode = this.visibleOptions.filter(({ icon }) => icon).length > 0;
  }

  constructor(
    @Self() @Optional() public ngControl: NgControl,
    private cd: ChangeDetectorRef
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.valueSubject.pipe(
        tap((newValue) => {
          console.log(newValue);

          this.visibleOptions.forEach(({ paramId }, index, all) => {
            all[index].picked = paramId === newValue;
          });
          this.cd.detectChanges();
        })
      ),
      this.control.valueChanges.pipe(
        tap((newValue) => {
          this.writeValue(newValue);
        })
      )
    );
  }

  resetOptions() {
    this.visibleOptions.forEach(
      (value, index1, array) => (array[index1].picked = false)
    );
  }

  pick(index) {
    console.log('pickewd');
    this.resetOptions();
    this.visibleOptions[index].picked = true;
    console.log(this.visibleOptions);
    this.writeValue(this.visibleOptions[index].paramId);
    this.cd.detectChanges();
  }

  trackOption(i, option: SingleOption) {
    return option.paramId;
  }
}
